import repository from '@/repositories/Repository'

const resource = '/ranks'

export default {
  get(company) {
    return repository.bizoo.get(`${resource}/${company}`).then(r => r.data)
  },
}
